import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { ReturnShippingInstructionsEmailRenderer } from "./email";
import type { ReturnShippingInstructionsBlockProps } from "./types";

export function ReturnShippingInstructionsEditorRenderer(
  props: ReturnShippingInstructionsBlockProps,
) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <ReturnShippingInstructionsEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
